import { gql } from "@apollo/client";

export const CREATE_INDICACION_BAP = gql`
    mutation CreateIndicacionBAP($input: AddEvaluacionBAPInput!, $idEvaluacion: Int!)
    {
        createIndicacionBAP(input: $input, idEvaluacion: $idEvaluacion) 
        {
            idEvaluacionBAP
            idEvaluacion
        }
    }
`;